import { render, staticRenderFns } from "./sortGoods.vue?vue&type=template&id=28e84a78&scoped=true&"
import script from "./sortGoods.vue?vue&type=script&lang=js&"
export * from "./sortGoods.vue?vue&type=script&lang=js&"
import style0 from "./sortGoods.vue?vue&type=style&index=0&id=28e84a78&prod&langs=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e84a78",
  null
  
)

export default component.exports